"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareFilters = exports.mapper = exports.getActiveFiltersCount = exports.filterObjects = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _types = require("../types");
var _filters = require("../types/filters");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Маппер из типа объекта в фильтр
 *
 * @param objectType - тип объекта
 */
const mapper = objectType => {
  switch (objectType) {
    case _types.EObjectType.COTTAGE:
    case _types.EObjectType.HOUSE:
    case _types.EObjectType.HOUSE_SHARE:
      return _filters.EFilters.HOUSE;
    case _types.EObjectType.TOWNHOUSE:
      return _filters.EFilters.TOWNHOUSE;
    case _types.EObjectType.LAND:
      return _filters.EFilters.LAND;
    default:
      return _filters.EFilters.HOUSE;
  }
};
exports.mapper = mapper;
const getActiveFiltersCount = filters => Object.values(filters).filter(Boolean).length;

/**
 * Приводит фильтры к рабочему формату
 *
 * @param filters - фильтры в формате типа объектов
 */
exports.getActiveFiltersCount = getActiveFiltersCount;
const prepareFilters = filters => {
  return filters.reduce((result, objectType) => _objectSpread(_objectSpread({}, result), {}, {
    [mapper(objectType)]: true
  }), {});
};

/**
 * Фильтрует объекты генплана по активным фильтрам
 *
 * @param objects - объекты генплана
 * @param filters - активные фильтры
 */
exports.prepareFilters = prepareFilters;
const filterObjects = (objects, filters) => {
  if (!filters) {
    return objects;
  }
  return objects.filter(object => object.objectType && filters[mapper(object.objectType)]);
};
exports.filterObjects = filterObjects;